import { useRoute } from 'vue-router'

export function useRoutePath() {
  const route = useRoute()
  if (route) {
    return {
      routePath: toRef(() => route.path),
      isRouterPath: true,
    }
  }
  return {
    routePath: ref(window.location.pathname),
    isRouterPath: false,
  }
}
